<script setup lang="ts">
import { faLocationDot } from '@fortawesome/pro-solid-svg-icons';
import ImageCarousel from '@components/util/ImageCarousel.vue';
import type TrainTourPackage from '@itinerary/trip/train/TrainTourPackage';
import { type HotelResponseHotel } from '@clients/HotelApi';

const { tripPackage } = defineProps<{
    tripPackage: TrainTourPackage;
}>();
const loading = ref(true);
const hotel = ref<HotelResponseHotel>();
const photos = computed(() => {
    if (hotel.value?.allPhotos?.length) {
        return hotel.value.allPhotos;
    }
    return [];
});
onBeforeMount(() => {
    tripPackage.hotel
        .then(res => {
            hotel.value = res;
        })
        .finally(() => {
            loading.value = false;
        });
});
</script>

<template>
    <Loading v-if="loading && !hotel" />
    <div v-else class="root" v-bind="$attrs">
        <div class="top">
            <div class="slider-section">
                <ImageCarousel no-slider :images="photos" />
            </div>
            <div class="rules">
                <div
                    v-for="(rule, index) in tripPackage.hotelDescriptions"
                    :key="index"
                    class="rule"
                >
                    {{ rule }}
                </div>
            </div>
            <a
                target="_blank"
                :href="`https://www.google.com/maps?q=${hotel!.latitude},${
                    hotel!.longitude
                }`"
            >
                <div class="address-container">
                    <mr-icon
                        class="icon"
                        :icon="faLocationDot"
                        color="var(--cool-gray-400)"
                        size="small"
                    />
                    <div class="address">
                        {{ hotel!.address }}
                    </div>
                </div>
            </a>
        </div>
        <a
            target="_blank"
            :href="`https://www.google.com/maps?q=${hotel!.latitude},${
                hotel!.longitude
            }`"
        >
            <div class="address-container">
                <mr-icon
                    class="icon"
                    :icon="faLocationDot"
                    color="var(--cool-gray-300)"
                    size="small"
                />
                <div class="address">
                    {{ hotel!.address }}
                </div>
            </div>
        </a>
    </div>
</template>

<style lang="scss" scoped>
.root {
    display: flex;
    flex-direction: column;
}
.top {
    display: flex;
    @include mobile-only {
        flex-direction: column;
    }
}
.slider-section {
    width: 300px;
    height: 200px;
    margin-left: 16px;
    @include mobile-only {
        margin-left: 0;
        width: 100%;
    }
}
.rules {
    display: flex;
    flex-direction: column;
    margin-right: 16px;
    @include mobile-only {
        margin-right: 0;
    }
}
.rule {
    border-radius: 8px;
    border: 1px solid usePalette($p-cool-gray);
    padding: 6px 16px;
    background-color: white;
    font-size: 12px;
    @include font-weight(500);
    margin-top: 2px;
    margin-bottom: 2px;
    width: fit-content;
    text-align: justify;
}
.address-container {
    display: flex;
}
a {
    color: usePalette($p-cool-gray, $p-800);
}
</style>
